import $ from 'jquery';

/**
 * Firefox has a weird behaviour where it retains some of the earlier pages'
 * scrollTop() in later pages, even if the later pages was never scrolled:
 *
 * 1. Scroll an overflow:auto area down on an issue page
 * 2. Flip the pages forward a few times
 * 3. At some point a later page will have the scrollTop() of the earlier 
 *    page that you scrolled down in
 */
export default function init( pluginApi ) {
  pluginApi.addAction( 'reader_page_loaded', 'asmag_reader_plugin', function( index, pageElem ) {
    window.setTimeout( function() {
      $( pageElem ).find( '.scroll' ).scrollTop( 0 );
    }, 50 );
  } );
}
